import { GoogleLogo } from '@phosphor-icons/react';

/**
 * "Continue with Google" trigger. Redirects to Emergent's OAuth broker.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * The redirect URL is derived from window.location.origin so preview vs. prod
 * always come back to the correct environment.
 */
const GoogleAuthButton = ({ label = 'Continue with Google', testId = 'google-signin-btn' }) => {
  const handleClick = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="w-full flex items-center justify-center gap-2.5 bg-white hover:bg-gray-50 border-2 border-gray-200 hover:border-gray-300 text-gray-800 px-5 py-3 rounded-xl text-sm font-semibold transition-colors"
      data-testid={testId}
    >
      <GoogleLogo size={18} weight="bold" className="text-[#4285F4]" />
      {label}
    </button>
  );
};

export default GoogleAuthButton;
